import { DeviceHealthReconciliationResponseSchema, EfemPeripheralHealthListQuerySchema, EfemPeripheralHealthListResponseSchema, GatewayHealthListQuerySchema, GatewayHealthListResponseSchema, GuardDashboardListQuerySchema, GuardDashboardListResponseSchema, OpsPeripheralProbeResponseSchema, UnattestedAttemptDetailResponseSchema, UnattestedAttemptListQuerySchema, UnattestedAttemptListResponseSchema, } from '../../schemas.js';
import { OpsPeripheralProbeRequestSchema, OpsSerialNumberParamSchema, } from '../../schemas/ops-devices.schemas.js';
import { UnattestedAttemptIdParamSchema } from '../../schemas/ops-health.schemas.js';
/** REST contract for `insight-api/.../ops-gateway-health.routes.ts`. */
export const opsGatewayHealthContract = {
    list: {
        method: 'GET',
        path: '/provider/ops/gateway-health',
        query: GatewayHealthListQuerySchema,
        response: GatewayHealthListResponseSchema,
        responseStyle: 'parse-response',
        queryLimitMax: 200,
        errorMessage: 'Failed to list gateway health',
    },
    probePeripherals: {
        method: 'POST',
        path: '/provider/ops/gateway-health/:serialNumber/peripherals/probe',
        pathParams: OpsSerialNumberParamSchema,
        body: OpsPeripheralProbeRequestSchema,
        response: OpsPeripheralProbeResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to probe EFEM peripherals',
    },
};
/** REST contract for `insight-api/.../ops-guard-dashboard.routes.ts`. */
export const opsGuardDashboardContract = {
    list: {
        method: 'GET',
        path: '/provider/ops/guard-dashboard',
        query: GuardDashboardListQuerySchema,
        response: GuardDashboardListResponseSchema,
        responseStyle: 'parse-response',
        queryLimitMax: 200,
        errorMessage: 'Failed to list guard dashboard',
    },
};
/** REST contract for `insight-api/.../ops-unattested.routes.ts`. */
export const opsUnattestedContract = {
    list: {
        method: 'GET',
        path: '/provider/ops/unattested',
        query: UnattestedAttemptListQuerySchema,
        response: UnattestedAttemptListResponseSchema,
        responseStyle: 'parse-response',
        queryLimitMax: 200,
        errorMessage: 'Failed to list unattested attempts',
    },
    getDetail: {
        method: 'GET',
        path: '/provider/ops/unattested/:attemptId',
        pathParams: UnattestedAttemptIdParamSchema,
        response: UnattestedAttemptDetailResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get unattested attempt detail',
    },
};
/** REST contract for `insight-api/.../ops-efem-peripherals.routes.ts`. */
export const opsEfemPeripheralsContract = {
    list: {
        method: 'GET',
        path: '/provider/ops/efem-peripherals',
        query: EfemPeripheralHealthListQuerySchema,
        response: EfemPeripheralHealthListResponseSchema,
        responseStyle: 'parse-response',
        queryLimitMax: 200,
        errorMessage: 'Failed to list EFEM peripheral health',
    },
};
/** REST contract for `insight-api/.../ops-device-health-reconciliation.routes.ts`. */
export const opsDeviceHealthReconciliationContract = {
    getSummary: {
        method: 'GET',
        path: '/provider/ops/device-health-reconciliation',
        response: DeviceHealthReconciliationResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get device health reconciliation',
    },
};
//# sourceMappingURL=provider-ops-health.contract.js.map